import { useLocation } from 'react-router-dom';

export const useQueryParams = () => {
	const query = new URLSearchParams(useLocation().search);
	if (decodeURIComponent(query.toString())) {
		return JSON.parse(
			'{"' +
				decodeURIComponent(query.toString())
					.replace(/"/g, '\\"')
					.replace(/&/g, '","')
					.replace(/=/g, '":"') +
				'"}'
		);
	} else {
		return null;
	}
};
